export default "__VITE_ASSET__86605375__"